import { render, staticRenderFns } from "./PageParentWrapper.vue?vue&type=template&id=1eb38e17&"
import script from "./PageParentWrapper.vue?vue&type=script&lang=js&"
export * from "./PageParentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports